import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
    selector: '[appInteract]'
})
export class InteractDirective {
    @Output() interact = new EventEmitter<Event>();

    @HostListener('click', ['$event'])
    onClick(event: MouseEvent): void {
        this.interact.emit(event);
    }

    @HostListener('keydown.enter', ['$event'])
    onEnter(event: Event): void {
        this.interact.emit(event);
    }

    @HostListener('keydown.space', ['$event'])
    onSpace(event: Event): void {
        event.preventDefault(); // Prevent page scrolling
        this.interact.emit(event);
    }
}
